import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { NoWrap } from '../../primitives/Typography/NoWrap.js';
export const Truncate = /*#__PURE__*/_styled(NoWrap, process.env.NODE_ENV === "production" ? {
  target: "ex8gw660"
} : {
  target: "ex8gw660",
  label: "Truncate"
})(process.env.NODE_ENV === "production" ? {
  name: "fzu03x",
  styles: "text-overflow:ellipsis;overflow:hidden"
} : {
  name: "fzu03x",
  styles: "text-overflow:ellipsis;overflow:hidden/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlRydW5jYXRlLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUV1QyIsImZpbGUiOiJUcnVuY2F0ZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IE5vV3JhcCB9IGZyb20gJy4uLy4uL3ByaW1pdGl2ZXMvVHlwb2dyYXBoeS9Ob1dyYXAuanMnO1xuZXhwb3J0IGNvbnN0IFRydW5jYXRlID0gc3R5bGVkKE5vV3JhcCkgYFxuICB0ZXh0LW92ZXJmbG93OiBlbGxpcHNpcztcbiAgb3ZlcmZsb3c6IGhpZGRlbjtcbmA7XG4vLyMgc291cmNlTWFwcGluZ1VSTD1UcnVuY2F0ZS5qcy5tYXAiXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});